export const FontSize = {
    head: {
        default: '24px',
        h1: '28px',
        h2: '24px',
        h3: '20px',
    },
    normal: {
        default: '14px',
        p1: '18px',
        p2: '16px',
        p3: '14px',
        p4: '12px',
    },
    sub: {
        default: '12px',
        s1: '12px',
        s2: '10px',
    }
}